// wraps everything inside the tooltip. The wrapping done instead of simply adding a component under it is to easily keep track of
// the tooltip trigger. I suppose I could've devised a way to keep track of the trigger, but that would've required dealing with css
// myself, so this is better

import { Tooltip, TooltipContent, TooltipTrigger } from "../../ui/tooltip";

// returns children if there is no tooltip available, can work for both headers and cells
export const TooltipWrapper = ({ tipText, children }) => {
  if (!tipText) return children;

  return (
    <Tooltip delayDuration={0}>
      <TooltipTrigger asChild>
        <div>{children}</div>
      </TooltipTrigger>
      <TooltipContent>
        <p className="text-base">{tipText}</p>
      </TooltipContent>
    </Tooltip>
  );
};

export default TooltipWrapper;
